import React, {Component} from 'react';
import styles from './FJRecordingTiming.module.less';
import InlineSVG from "react-inlinesvg";
import recordStop from '../../../../icon/recordStop.svg';
import FJLocalStore from "../../../../store/FJLocalStore";
import FJCoreUtil from "../../../../core/util/FJCoreUtil";

class FJRecordingTiming extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minute: '00',
      second: '00',
    }
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.visible !== this.props.visible && this.props.visible) { // 开始计时
      this._timeShow();
    } else if (prevProps.visible !== this.props.visible && !this.props.visible) { // 结束计时
      this._endTiming();
    }
  }

  componentWillUnmount() {
  }

  _timingOut = null;
  _worker = null;

  /**
   * @description 录像时 显示录下录屏时间
   * @private
   */
  _timeShow = () => {
    this.setState({
      minute: '00',
      second: '00'
    });

    if(typeof(Worker)!=="undefined") {
      if (FJCoreUtil.getBrowser() === 'FF') {
        this._startWorkerTimingInFireFox();
      } else {
        this._startWorkerTiming();
      }
      // 是的! Web worker 支持!
    } else {
      this._startTiming();
      // 抱歉! Web Worker 不支持
    }
  };

  /**
   * @description 开始录制计时
   * @private
   */
  _startTiming = () => {
    let start;
    let _this = this;
    function step(timestamp) {
      if (!start) start = timestamp;
      let progress = Math.floor((timestamp - start) / 1000);
      let m = parseInt(progress / 60, 0) % 60;
      let s = progress % 60;

      if (m >= 10) {
        _this.props.endRecording();
      } else {
        _this._timingOut = window.requestAnimationFrame(step);
      }

      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      _this.setState({
        minute: m,
        second: s
      });
    }
    this._timingOut = window.requestAnimationFrame(step);
  };

  /**
   * @description 关闭录制计时
   * @private
   */
  _endTiming = () => {
    this._endWorkerTiming();
    window.cancelAnimationFrame(this._timingOut);
    this._timingOut = null;
  };

  /**
   * @description 开始录屏倒计时（worker）
   * @private
   */
  _startWorkerTiming = () => {
    let _this = this;
    let str = `
            let timeOut = null;
            let start;
            function step(timestamp) {
                if (!start) start = timestamp;
                let progress = Math.floor((timestamp - start) / 1000);
                let m = parseInt(progress / 60) % 60;
                if (m >= 10) {
                    cancelAnimationFrame(timeOut)
                    self.postMessage({timeOut: timeOut, seconds: 600})
                    self.close()
                } else {
                    self.postMessage({timeOut: timeOut, seconds: progress})
                    timeOut = requestAnimationFrame(step)
                }
                
            };
            timeOut = requestAnimationFrame(step)
        `;
    let blob = new Blob([str]);
    this._worker = new Worker(window.URL.createObjectURL(blob));

    this._worker.onmessage = function (e) {
      _this._timingOut = e.data.timeOut;
      let progress = e.data.seconds;
      let m = parseInt(progress / 60, 0) % 60;
      let s = progress % 60;

      if (m >= 10) {
        _this._worker.terminate();
        _this.props.endRecording();
      }

      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      _this.setState({
        minute: m,
        second: s
      });
    }
  };

  /**
   * @description 开始录屏倒计时（worker）在火狐浏览器中
   * @private
   */
  _startWorkerTimingInFireFox = () => {
    let _this = this;
    let str = `
            let timeOut = null;
            let progress = 0;
            timeOut = setInterval(() => {
              progress++;
              let m = parseInt(progress / 60) % 60;
              if (m >= 1) {
                clearInterval(timeOut);
                timeOut = null;
                self.postMessage({timeOut: timeOut, seconds: 600})
                self.close()
              } else {
                self.postMessage({timeOut: timeOut, seconds: progress})
              }
            }, 1000);
        `;
    let blob = new Blob([str]);
    this._worker = new Worker(window.URL.createObjectURL(blob));

    this._worker.onmessage = function (e) {
      _this._timingOut = e.data.timeOut;
      let progress = e.data.seconds;
      let m = parseInt(progress / 60, 0) % 60;
      let s = progress % 60;

      if (m >= 10) {
        _this._worker.terminate();
        _this.props.endRecording();
      }

      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      _this.setState({
        minute: m,
        second: s
      });
    }
  };

  /**
   * @description 结束录屏倒计时（worker）
   * @private
   */
  _endWorkerTiming = () => {
    this._worker && this._worker.terminate();
    this._worker = null;
  };

  render() {
    const {minute, second} = this.state;
    let {
      endRecording
    } = this.props;
    return (
      <div className={styles.box}>
        <div className={styles.title}>{FJLocalStore._("do-recording")}</div>
        <div className={styles.btn} onClick={endRecording}>
          <InlineSVG src={recordStop} element='div'/>
        </div>
        <div className={styles.times}>
          {minute}:{second}/10:00
        </div>
      </div>
    )
  }
}

export default FJRecordingTiming;
